import * as React from "react";
const B1 = (props) => (
  <svg
    width={25}
    height={28}
    viewBox="0 0 25 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.55029 13.6749L12.0411 16.1658L16.414 11.793"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.98486 1.5V5.24813"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9795 1.5V5.24813"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9797 3.37408C22.1401 3.59897 24.2265 5.18568 24.2265 11.0577V18.7789C24.2265 23.9263 22.9772 26.5 16.7303 26.5H9.23405C2.98717 26.5 1.73779 23.9263 1.73779 18.7789V11.0577C1.73779 5.18568 3.82425 3.61147 7.98467 3.37408H17.9797Z"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9144 20.9904H2.05029"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default B1;
